/**
 * Rating-row display helpers.
 *
 * "Legacy import" was the placeholder value stamped onto pre-launch
 * rating rows during the historical data migration (see
 * `backend/ratings_migration.py`) whenever the source spreadsheet was
 * missing a rider name or session type. The value lives in the DB
 * indefinitely so that ranking calculations remain traceable — but
 * the operator team doesn't want to *see* it anywhere in the UI.
 *
 * `stripLegacyLabel` returns `""` (falsy) whenever the incoming value
 * looks like the placeholder, otherwise it returns the value untouched.
 * Rendering code can then use short-circuit patterns like:
 *
 *     {stripLegacyLabel(c.competition_type) && (
 *       <span className="pill">{stripLegacyLabel(c.competition_type)}</span>
 *     )}
 *
 * We match case-insensitively and trim surrounding whitespace to catch
 * every historical variant that was written into the collection.
 */
export function stripLegacyLabel(value) {
  if (value === null || value === undefined) return "";
  const s = String(value).trim();
  if (!s) return "";
  if (s.toLowerCase() === "legacy import") return "";
  return s;
}

/**
 * Convenience: returns `true` when the given rating-row field is the
 * legacy-import placeholder. Handy for gating whole cells / columns
 * without threading the ternary through JSX twice.
 */
export function isLegacyLabel(value) {
  if (value === null || value === undefined) return false;
  return String(value).trim().toLowerCase() === "legacy import";
}
